import { Component, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
// import { AuthResponse, ServerHashParamKeys } from 'msal';
import { AppComponent } from '../../app.component';
import { ConfigService } from '../../share/services/config.service';

// import * as L from 'leaflet';
// import 'leaflet-wms-header';
// import 'mapbox-gl-leaflet'; // TODO don't we need this ?
declare const L: any;

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css']
})
export class MapComponent implements OnInit, AfterViewInit {
  private map!: L.Map;
  // account;
  // memberId;
  token: string = '';
  @ViewChild('map')
  private mapContainer!: ElementRef<HTMLElement>;

  constructor(
    private appComponent: AppComponent,
    private auth: MsalService,
    private configService: ConfigService
  ) {}
  ngOnInit() {}

  ngAfterViewInit() {

    var layerNames = 'Fetrapi:Fetrapi_p_20200430,Fetrapi:Fetrapi_Site_20200430,Fetrapi_b_20200430,Fetrapi_c_20200430,Fetrapi_s_20200430';

    //var osmUrl = 'http://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png';
    //var osmAttrib = 'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors';
    //var osm = new L.TileLayer(osmUrl, { minZoom: 0, maxZoom: 19, attribution: osmAttrib });
    //map.addLayer(osm);

    const fetrapiApi = this.configService.getEnv('fetrapiApi') + 'GeoProxy?';

    var URBISLayer = L.tileLayer.wms(
      this.configService.getEnv('geoservicesBR'),
      { layers: 'urbisFR', transparent: true, format: 'image/png' }
    );
    var PICCLayer = L.tileLayer.wms(
      this.configService.getEnv('geoservicesWA'),
      {
        layers:
          '1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24,25,26,27,28,29',
        transparent: true,
        format: 'image/png',
      }
    );
    var GRBLayer = L.tileLayer.wms(this.configService.getEnv('geoservicesFL'), {
      layers: 'GRB_BSK',
      transparent: true,
      format: 'image/png',
    });

    var BEACONLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_beacon_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var CCPWLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_ccpw_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var PIPELINELayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_pipeline_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var SITELayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_site_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var STATIONLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_station_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);

    var BEACONSTAGLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_beacon_stag_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var CCPWSTAGLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_ccpw_stag_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var PIPELINESTAGLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_pipeline_stag_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var SITESTAGLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_site_stag_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);
    var STATIONSTAGLayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_station_stag_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);

    var ZOILayer = L.TileLayer.wmsHeader(fetrapiApi, { layers: 'FetrapiBaseData:vw_fet_zoi_prod_f', transparent: true, format: 'image/png' }, [{ header: 'Authorization', value: "Bearer " + this.token }]);

    //var crs = new L.Proj.CRS('EPSG:31370', '+proj=lcc +lat_1=51.16666723333333 +lat_2=49.8333339 +lat_0=90 +lon_0=4.367486666666666 +x_0=150000.013 +y_0=5400088.438 +ellps=intl +towgs84=-106.869,52.2978,-103.724,0.3366,-0.457,1.8422,-1.2747 +units=m +no_defs',
    //    {
    //        resolutions: [8192, 4096, 2048, 1024, 512, 256, 128, 64, 32, 16, 8] // zoom level resolutions
    //    }
    //);

    var backdrop = L.layerGroup([URBISLayer, PICCLayer, GRBLayer]);
    var featureLayer = L.layerGroup([BEACONLayer, CCPWLayer, PIPELINELayer, SITELayer, STATIONLayer/*, BEACONSTAGLayer, CCPWSTAGLayer, PIPELINESTAGLayer, SITESTAGLayer, STATIONSTAGLayer, ZOILayer*/]);

    var map = new L.Map('map', { center: [50.84673, 4.35247], zoom: 9, worldCopyJump: false, /*crs: crs,*/ layers: [backdrop, featureLayer] });

    var start_at_zoom = 8;
    var myLayerStyle = {
        color: 'Red',
        radius: 8
    }

    //var baseMaps = { "PICC/CRAB/URBIS": backdrop };
    var overlayMaps = {
        "URBIS": URBISLayer, "PICC": PICCLayer, "GRB": GRBLayer,
        "Beacon Prod": BEACONLayer, "CCPW Prod": CCPWLayer, "Pipelines Prod": PIPELINELayer, "Sites Prod": SITELayer, "Stations Prod": STATIONLayer,
        "Beacon Stage": BEACONSTAGLayer, "CCPW Stage": CCPWSTAGLayer, "Pipelines Stage": PIPELINESTAGLayer, "Sites Stage": SITESTAGLayer, "Stations Stage": STATIONSTAGLayer,
        "ZoI": ZOILayer
    };
    L.control.layers(undefined, overlayMaps).addTo(map);

  }
}
